import { h, Component }  from "preact";
import { connect }       from "preact-redux";
import { shallowEquals } from "diskho";
import { Route, Switch } from "react-router";
import {
  PENDING as CMS_PAGES_PENDING,
  load    as loadCmsPages }        from "store-reducers/cmsPages";  
import { closeAll as closeModals } from "store-reducers/modals";

import Translation      from "helpers/translation";
import formatPrice      from "helpers/formatPrice.js";
import formatDate       from "helpers/formatDate.js";

import App from "containers/App";
import Login from "containers/Login";
import Logout from "containers/Logout";
import Procurement from "containers/Procurement";
import SuccessView from "containers/SuccessView";
import RouteView from "containers/RouteView";
import Redirect from "components/Redirect";

const AuthRoute = ({ component: Component, ...rest }, { store }) => {
  return (
    <Route
        {...rest}
        render={props =>
          store.getState().customer.loggedIn ?
            <Component {...props} /> :
            <Redirect to="/login" />
        } />
  );
};

@connect(
  state => ({
    openModalsCount : state.modals.length,
    location        : state.router.location,
    loggedIn        : state.customer.loggedIn,
    pagesPending    : state.cmsPages.state === CMS_PAGES_PENDING,
  }),
  dispatch => ({
    closeModals  : () => dispatch(closeModals()),
    loadCmsPages : () => dispatch(loadCmsPages()),
  })
)
export default class Routes extends Component {
  loadRequiredData = props => {
    if (props.pagesPending) {
      props.loadCmsPages();
    }
  };

  loadDeferredData = props => {};

  getChildContext = () => {
    const t = new Translation(this.props.translation);

    return {
      t           : t.translate.bind(t),
      formatDate  : formatDate(t.translate("LOCALE.ISO.IETF")),
      formatPrice : formatPrice({
        id        : t.translate("LOCALE.ISO.IETF"),
        currency  : t.translate("LOCALE.CURRENCY"),
        symbol    : t.translate("LOCALE.FALLBACK_CURRENCY")
      }),
    };
  }

  componentWillMount() {
    this.loadRequiredData(this.props);
  }

  componentDidMount() {
    this.loadDeferredData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadRequiredData(nextProps);
    this.loadDeferredData(nextProps);

    if (nextProps.location.pathname !== this.props.location.pathname && this.props.openModalsCount > 0) {
      this.props.closeModals();
    }
  }

  shouldComponentUpdate({ location }) {
    return !shallowEquals(location, this.props.location);
  }

  render({ config, location }) {
    return (
      <App config={config}>
        <Switch location={location}>
          <AuthRoute path="/"                 exact component={Procurement} />
          <Route     path="/login"            exact component={Login} />
          <AuthRoute path="/logout"           exact component={Logout} />
          <AuthRoute path="/checkout/success" exact component={SuccessView} />
          <Route     path="/(.+)"                   component={RouteView} />
        </Switch>
      </App>
    );
  }
}
